<template>
  <div class="social">
    <div v-for="(item, index) in items" :key="index">
      <a v-if="item.value !== ''" :href="item.value">
        <font-awesome-icon :icon="['fab', item.icon]" size="2x" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "fcwpSocial",
  props: ["items"],
};
</script>

<style scoped lang="scss">
.social {
  position: relative;
  float: right;
  top: 50px;
  background-color: rgba($primary-color, 0.6);
  border-radius: 5px 0px 0px 5px;
  z-index: 1300;
  a {
    margin: 8px;
    font-size: 15pt;
    display: block;
    text-decoration: none;
    color: rgb($quaternary-color);
  }
  a:hover {
    color: rgb($secondary-color);
  }
  svg, i {
    width: 0.875em;
  }
}

.jumbotron-image,
.jumbotron-video {
  .social {
    right: 2vw;
    border-radius: 5px;
  }
  .social a {
    margin: 0.5vw;
    font-size: 1.5vw;
  }
}

@media (max-width: 1199px) {
  .social a,
  .specials a {
    font-size: 15pt;
  }
  .jumbotron-image,
  .jumbotron-video {
    .social a,
    .specials a {
      font-size: 1.5vw;
    }
  }
}

@media (max-width: 700px) {
  .social a,
  .specials a {
    margin: 4px;
    font-size: 10pt;
  }
  .jumbotron-image,
  .jumbotron-video {
    .social {
      right: 10px;
      a {
        font-size: 10pt;
      }
    }
    .specials a {
      font-size: 10pt;
    }
  }
}
</style>